import axios from 'axios'
import AuthService from '../services/auth.service'

const state = () => ({
  initialState: {
    status: {
      loggedIn: false,
    },
    user: null,
  },
  refreshPromise: null,
})

const getters = {
  loggedIn (state) {
    return state.initialState.status.loggedIn
  },
  user (state) {
    return state.initialState.user
  },
  getRefreshPromise (state) {
    return state.refreshPromise
  },
  setRefreshPromise (state, promise) {
    state.refreshPromise = promise
  },
}

const mutations = {
  loginSuccess (state, user) {
    state.initialState.status.loggedIn = true
    state.initialState.user = user.data
  },
  loginFailure (state) {
    state.initialState.status.loggedIn = false
    state.initialState.user = null
  },
  logout (state) {
    state.initialState.status.loggedIn = false
    state.initialState.user = null
  },
  setRefreshPromise (state, promise) {
    state.refreshPromise = promise
  },
}

const actions = {
  sendCode ({ commit, rootGetters }, phone) {
    const formattedPhone = phone ? phone.match(/[0-9]/g).join('') : null
    commit('setLoading', true, { root: true })

    return this.$axios
      .$post(rootGetters['api/authSendCode'], {
        phone: formattedPhone,
      })
      .finally(() => {
        commit('setLoading', false, { root: true })
      })
  },
  login ({ commit, rootGetters }, user) {
    const AS = new AuthService(rootGetters)

    return AS.login(user).then(
      (user) => {
        const EXPIRES_TIME = parseInt(new Date().getTime() / 1000) + 3600
        this.$cookies.set('token', user.token)
        this.$cookies.set('expires_in', EXPIRES_TIME)
        commit('loginSuccess', user)
        return Promise.resolve(user)
      },
      (error) => {
        commit('loginFailure')
        return Promise.reject(error)
      },
    )
  },
  handleLogin ({ commit, rootGetters }, promise) {
    return promise.then(
      (response) => {
        if (response.token) {
          axios.defaults.headers.common.Authorization = `Bearer ${response.token}`
          const EXPIRES_TIME = parseInt(new Date().getTime() / 1000) + 3600
          this.$cookies.set('token', response.token)
          this.$cookies.set('expires_in', EXPIRES_TIME)
        }

        commit('loginSuccess', response)
        return Promise.resolve(response)
      },
      (error) => {
        commit('loginFailure')
        return Promise.reject(error)
      },
    )
  },
  logout ({ commit, rootGetters }) {
    console.log('LOGOUT')
    commit('cart/setCart', null, { root: true })
    commit('cart/setCartItems', [], { root: true })
    commit('cart/setCartSummary', 0, { root: true })
    commit('client/setProfile', null, { root: true })
    commit('logout')
    this.$cookies.set('token', '')
    this.$cookies.remove('token')
    localStorage.removeItem('user')
  },

  me ({ commit, rootGetters }) {
    return this.$axios.$post(rootGetters['api/authMe'])
  },

  refresh ({ commit, getters, rootGetters, dispatch }) {
    if (!getters.getRefreshPromise) {
      // Create new refresh Promise
      // console.log('new RefreshPromise')

      const refreshPromise = axios
        .post(rootGetters['api/authRefresh'])
        .then((res) => {
          const user = JSON.parse(
            localStorage.getItem('user'),
          )
          if (user) {
            user.token = res.data.token
            localStorage.setItem(
              'user',
              JSON.stringify(user),
            )
          }

          // console.log('NEW TOKEN ' + res.data.token)

          axios.defaults.headers.common.Authorization = `Bearer ${res.data.token}`
          this.$cookies.set('token', res.data.token)
          localStorage.setItem('token', res.data.token)

          return res
        })
        .catch(e => console.error('ERROR while refresh token ' + e))
        .finally(() => {
          commit('setRefreshPromise', null)
          dispatch('cart/fetchCart', null, { root: true })
            .catch(err => console.error('axios plugin - cart/fetchCart - error', err))
        })
      commit('setRefreshPromise', refreshPromise)
    }

    return getters.getRefreshPromise
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
